import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import api from "@/lib/api";
import Logo from "@/components/Logo";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("checking"); // checking | paid | error | expired
  const [order, setOrder] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    if (!sessionId) {
      setStatus("error");
      return;
    }

    let attempts = 0;
    const poll = async () => {
      if (attempts >= 8) {
        setStatus("error");
        return;
      }
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setOrder(data);
          setStatus("paid");
          return;
        }
        if (data.status === "expired") {
          setStatus("expired");
          return;
        }
        setTimeout(poll, 1800);
      } catch (e) {
        setStatus("error");
      }
    };
    poll();
  }, []);

  return (
    <div className="min-h-screen bg-[#2E9EF0] flex items-center justify-center px-5" data-testid="payment-success-page">
      <div className="bg-white border-2 border-[#12263A] p-10 max-w-md w-full text-left" style={{ borderRadius: "32px" }}>
        <Logo size={40} />

        {status === "checking" && (
          <div className="mt-8 flex flex-col gap-4">
            <Loader2 size={40} className="text-[#2E9EF0] animate-spin" />
            <h1 className="text-[28px] font-black text-[#12263A] leading-tight">Confirmando tu pago…</h1>
            <p className="text-[15px] text-[#2A3D52]">Un segundo, estamos preparando tu Kiddio.</p>
          </div>
        )}

        {status === "paid" && (
          <div className="mt-8 flex flex-col gap-4" data-testid="payment-paid">
            <CheckCircle2 size={44} className="text-[#3CB878]" strokeWidth={2} />
            <h1 className="text-[28px] font-black text-[#12263A] leading-tight">¡Bienvenido a la familia Kiddio!</h1>
            <p className="text-[15px] leading-[1.6] text-[#2A3D52]">
              Tu pedido de <strong>{order?.plan_name}</strong> por <strong>${order?.amount}</strong> está confirmado.
              Te enviaremos el reloj y los detalles de configuración por correo.
            </p>
            <button
              onClick={() => navigate("/cuenta")}
              data-testid="go-account-btn"
              className="mt-2 px-6 py-4 rounded-[20px] bg-[#2E9EF0] text-[#12263A] border-2 border-[#12263A] font-bold hover:bg-[#12263A] hover:text-[#2E9EF0] transition-colors"
            >
              Ver mi cuenta
            </button>
          </div>
        )}

        {(status === "error" || status === "expired") && (
          <div className="mt-8 flex flex-col gap-4">
            <XCircle size={44} className="text-[#FF6B57]" strokeWidth={2} />
            <h1 className="text-[28px] font-black text-[#12263A] leading-tight">No pudimos confirmar el pago</h1>
            <p className="text-[15px] text-[#2A3D52]">Si el cobro se realizó, aparecerá en tu cuenta en unos minutos.</p>
            <button
              onClick={() => navigate("/")}
              className="mt-2 px-6 py-4 rounded-[20px] bg-[#F3F2F2] text-[#12263A] border-2 border-[#12263A] font-bold hover:bg-[#D6D9DC] transition-colors"
            >
              Volver al inicio
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
